import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {addAcBrandData} from "../../../redux/modules/AcBrand/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class AcBrandAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
        };
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.addAcBrandData(this.state);
    }

    render() {
        if (this.props.acBrand?.success) return <Redirect to="/ac-brand"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"Access brand name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    acBrand: state.acBrand,
});

const mapDispatchToProps = {
    addAcBrandData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcBrandAdd)
);
